import React, { useMemo } from 'react';
import type { OrderStepContext } from '../orderStepContext';
import OrderDraftEditor, { type OrderDraftEditorProps } from '../draft/OrderDraftEditor';
import { orderDraftFromOrder } from '../draft/orderDraftModel';

/**
 * Szkic (makieta `sSzkic`): the draft is created and edited here — customer,
 * delivery address, „Więcej danych”, lines with quantity and sale price, and
 * the „Ściąga logistyczna”. A new order uses the same editor before its first
 * save (`pages/OrderNew.tsx`). A later step shows the Szkic read-only
 * (`ctx.readOnly` or no editor): the lines as saved, no inputs.
 */
export default function DraftStep({
  ctx,
  editor,
  ...editorProps
}: { ctx: OrderStepContext } & Omit<OrderDraftEditorProps, 'draft' | 'isNew'>) {
  const savedDraft = useMemo(() => orderDraftFromOrder(ctx.order), [ctx.order]);
  const activeEditor = ctx.readOnly ? undefined : editor;
  return (
    <OrderDraftEditor
      {...editorProps}
      draft={activeEditor ? activeEditor.draft : savedDraft}
      editor={activeEditor}
      isNew={false}
    />
  );
}
